import { render, staticRenderFns } from "./ItemToolkit.vue?vue&type=template&id=dcb469c4&scoped=true&"
import script from "./ItemToolkit.vue?vue&type=script&lang=js&"
export * from "./ItemToolkit.vue?vue&type=script&lang=js&"
import style0 from "./ItemToolkit.vue?vue&type=style&index=0&id=dcb469c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb469c4",
  null
  
)

export default component.exports